import api from "../service/api";


export const getScholarProfile = async (id) => {
  return await api.get(`/sclr/scholar/${id}`);
};